export default __webpack_public_path__ + "static/media/Armguards of the Tireless Defender.4368e7ca.jpg";